import React from "react";
import styled from "styled-components";
import { Button, Modal } from "rsuite";
import Icon from "../Icon";

export default function ImageModal({ show, onClose, imageURL }) {
  return (
    <Container>
      <ModalCustom backdrop="static" show={show} onHide={onClose} size="full">
        <Modal.Header closeButton={false} style={{ paddingRight: 0 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
              position: "absolute",
              top: -30,
              right: 0,
              zIndex: 20,
            }}
          >
            <Button
              style={{ padding: ".2rem", fontWeight: 700 }}
              onClick={onClose}
              appearance="primary"
            >
              <Icon icon="close" size={"20"} />
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body style={{ marginTop: 4 }}>
          <img
            className="fixed-bottom"
            src={imageURL}
            width="100%"
            height="100%"
            alt="Congress Information"
          />
        </Modal.Body>
      </ModalCustom>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
`;
const ModalCustom = styled(Modal)`
  margin: 0 auto;
  margin-top: 50px;
  z-index: 10000;
  position: relative;

  width: 90%;
  max-width: 75vh;
  height: 740px;

  .rs-modal-content {
    padding: 8px;
  }
  @media screen and (max-width: 650px) {
    max-width: 1200px;
    max-height: 100%%;
  }
`;
